// Modules
import 'src/application/fancy-menu/menu'
import 'src/application/carousel'
import 'src/application/popover'
import 'src/application/sticky'
import 'src/application/horizontal-scroll'
import 'src/application/text-wrap-anywhere'
import 'src/application/table-stacked'
import 'src/application/marquee'
import 'src/application/platform-classes'

import { initClipboard } from 'src/application/clipboard'
document.addEventListener('DOMContentLoaded', initClipboard)

// The rest
import Rails from '@rails/ujs'
Rails.start()
